import { Cart } from 'src/components/context';

export interface SignedInPayload {
  /** The guest cart as it was immediately before the session switched. */
  guestCart: Cart | null;
  wooSessionToken: string | null;
}

type SignedInListener = (payload: SignedInPayload) => void;
type SignedOutListener = () => void;

/**
 * AuthProvider sits above AppProvider in the tree (it needs Apollo; the cart providers
 * need to react to it), so it cannot call setCart directly. It emits here instead, and
 * a headless CartAuthSync rendered inside CartProvider subscribes — which keeps the
 * provider ordering legal and AuthProvider cart-agnostic.
 */
const signedInListeners = new Set<SignedInListener>();
const signedOutListeners = new Set<SignedOutListener>();

export const onSignedIn = (listener: SignedInListener): (() => void) => {
  signedInListeners.add(listener);

  return () => signedInListeners.delete(listener);
};

export const onSignedOut = (listener: SignedOutListener): (() => void) => {
  signedOutListeners.add(listener);

  return () => signedOutListeners.delete(listener);
};

export const emitSignedIn = (payload: SignedInPayload): void => {
  signedInListeners.forEach(listener => listener(payload));
};

export const emitSignedOut = (): void => {
  signedOutListeners.forEach(listener => listener());
};

/** Test seam. */
export const __resetForTests = (): void => {
  signedInListeners.clear();
  signedOutListeners.clear();
};
